import { __decorate, __extends } from "tslib";
import { CustomElement, element, h, props } from '@wk/custom-element';
export var DEFAULT_CONTENT_PACEHOLDER_LINES_COUNT = 10;
export var DEFAULT_CONTENT_PLACEHOLDER_LABEL = 'Loading';
var ContentPlaceholderComponent = (function (_super) {
    __extends(ContentPlaceholderComponent, _super);
    function ContentPlaceholderComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.linesCount = DEFAULT_CONTENT_PACEHOLDER_LINES_COUNT;
        _this.label = DEFAULT_CONTENT_PLACEHOLDER_LABEL;
        return _this;
    }
    ContentPlaceholderComponent.prototype.renderCallback = function () {
        return (h("div", { className: "wk-content-placeholder" },
            h("span", { className: "wk-sr-only" }, this.label),
            this.generateLines()));
    };
    ContentPlaceholderComponent.prototype.generateLines = function () {
        return Array(this.linesCount).fill(h("div", { className: "wk-content-placeholder-line" }));
    };
    __decorate([
        props.number
    ], ContentPlaceholderComponent.prototype, "linesCount", void 0);
    __decorate([
        props.string
    ], ContentPlaceholderComponent.prototype, "label", void 0);
    ContentPlaceholderComponent = __decorate([
        element('wk-content-placeholder')
    ], ContentPlaceholderComponent);
    return ContentPlaceholderComponent;
}(CustomElement));
export { ContentPlaceholderComponent };
